function isValidEnvVar(name) {
  const value = import.meta.env[name];
  return (
    value !== undefined
    && value !== null
    && value !== ''
    && value !== 'undefined'
    && value !== 'null'
    && value !== 'none'
  );
}

export {
  isValidEnvVar,
};
